import angular from 'angular'
import terminalController from './roster.ctrl'
import terminal from './roster.html'
import mainMenu from '../../shared/menu/menu.html'
import menu from './menu.html'
import './roster.css'
import './absent-modal/absent-modal.css'
import './excused-all-absent-modal/excused-all-absent-modal.css'
import FutureShiftsService from "../../services/future-shift-service/future-shifts.service";
import RosterUserCertificationService from "./rosterUserCertification.service";

export default angular.module('roster', ['ui.router'])
  .service('futureShiftService', FutureShiftsService)
  .service('rosterUserCertificationService', RosterUserCertificationService)
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.roster', {
      url: '/roster/:date?tab',
      params: {
        date: { squash: true, dynamic: true, value: null }
      },
      resolve: {
        myCrews: (Crews) => {
          'ngInject'
          return Crews.getCrews()
        },
        userInfo: (Auth) => {
          'ngInject'
          return Auth.getDetails()
        },
        v2Token: (Auth) => {
          'ngInject'
          return Auth.getV2Token()
        },
        company: (Companies) => {
          'ngInject'
          return Companies.getCompanyData()
        }
      },
      views: {
        content: {
          controller: terminalController,
          controllerAs: 't',
          template: terminal
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
  })
